import Controller from '@ember/controller';
import { service } from '@ember/service';

import { isDevelopingApp, macroCondition } from '@embroider/macros';

import ENV from 'register-partners-js/config/environment';

export default class ApplicationController extends Controller {
  @service zendeskWidget;

  constructor() {
    super(...arguments);
    if (macroCondition(isDevelopingApp())) {
      document.title = 'Qonto - dev';
    } else {
      // eslint-disable-next-line no-console
      console.log('app version:', ENV.qontoAppVersion);
    }
  }

  get isProduction() {
    return this.zendeskWidget.isProduction;
  }
}
